import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { Avatar } from '@segment/react-ui-library'
import css from './ListItem.module.css'

const CustomerProfileListItem = ({ id, name = 'Anonymous User', avatar, updatedAt, ...props }) => (
  <Link className={css.item} {...props}>
    <Avatar display='flex' imageSize='small' src={avatar}>
      {name}
    </Avatar>

    <div className={css.content}>
      <span className={css.name}>{name}</span>
      <span className={css.id}>{` - ${id}`}</span>
    </div>

    <div className={css.time}>
      {updatedAt}
    </div>
  </Link>
)

CustomerProfileListItem.propTypes = {
  id: PropTypes.string,
  email: PropTypes.string,
  name: PropTypes.string,
  updatedAt: PropTypes.string
}

export default CustomerProfileListItem



// WEBPACK FOOTER //
// ./components/Customers/CustomersProfiles/ListItem.js